<template>
  <div>
    <div class="header__breaking-news d-none d-sm-flex">
      <div class="container">
        <div class="header__breaking-news__inner">
          <div class="inner__carousel owl-carousel owl-loaded">
            <carousel ref="carousel" :data="topNews" :controls="false" :indicators="false" :interval="3000"
              :pauseOnEnter="false" direction="up"></carousel>
            <div class="owl-nav">
              <div class="owl-prev" v-on:click="prevNews()">
                <i class="fa fa-angle-left"></i>
              </div>
              <div class="owl-next" v-on:click="nextNews()">
                <i class="fa fa-angle-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section has-posts multi-category-posts u-padding-tb-40">
      <div class="container">
        <div v-if="advertisements.aboveTopNewsAd != null &&
          advertisements.premiumBillboardAd == null
          " class="ad-728-90-topnews-above">
          <a v-bind:href="advertisements.aboveTopNewsAd.advertisersWebPage" v-on:click="
            updateAdvertisementClicks(
              advertisements.aboveTopNewsAd.advertisementID
            )
            " target="_blank">
            <img v-bind:src="advertisements.aboveTopNewsAd.absolutePhotoUrl" /></a>
        </div>
        <div v-else-if="advertisements.premiumBillboardAd != null" class="ad-970-250-topnews-above">
          <a v-bind:href="advertisements.premiumBillboardAd.advertisersWebPage" v-on:click="
            updateAdvertisementClicks(
              advertisements.premiumBillboardAd.advertisementID
            )
            " target="_blank">
            <img v-bind:src="advertisements.premiumBillboardAd.absolutePhotoUrl" /></a>
        </div>
        <div v-else class="ad-728-90-topnews-above">
          <GoogleAdSense :adSlot="'3661589434'" :width="728" :height="90" />
        </div>

        <div class="u-flex u-flex--wrap n-margin-lr-3">
          <article v-on:click="read(post.postID, post.searchCode, post.categoryCode)" v-for="(post, i) in topPosts"
            :key="'topPosts_' + post.postID" class="grid-item cursor-pointer">
            <figure>
              <span class="breaking-news" v-if="post.isBreakingNews" style="display: inline-block"><router-link :to="{
                name: 'read',
                params: {
                  category: post.categoryCode,
                  slug: post.searchCode,
                  id: post.postID,
                },
              }">
                  style="background:red;">Ekskluzivno</router-link></span>
              <img v-lazy="i == 0 || i == 1
                ? post.absolutePhotoUrl
                : post.absoluteThumbUrl
                " v-bind:style="{
    border: post.isBreakingNews ? '2px solid red' : '',
  }" v-bind:alt="post.title" />
            </figure>
            <div class="thumb-content">
              <div class="post-cat">
                <ul>
                  <li style="display: inline-block">
                    <router-link :to="{
                      name: 'read',
                      params: {
                        category: post.categoryCode,
                        slug: post.searchCode,
                        id: post.postID,
                      },
                    }" v-bind:style="{
  background: post.postCategoryBorderColor,
}">{{ post.postCategory }}</router-link>
                  </li>
                </ul>
              </div>
              <h2 class="post-title">
                <router-link :to="{
                  name: 'read',
                  params: {
                    category: post.categoryCode,
                    slug: post.searchCode,
                    id: post.postID,
                  },
                }">{{
  post.shortTitle ? post.shortTitle : post.title
}}</router-link>
              </h2>
              <div class="post-meta">
                <i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }}
              </div>
            </div>
          </article>
        </div>
        <div id="garminTopNewsBelowAd728x90" v-if="(new Date().getDate() == 8 || new Date().getDate() == 15) &&
          new Date().getMonth() + 1 == 9
          " class="ad-728-90-topnews-below"></div>
        <div v-if="advertisements.belowTopNewsAd != null" class="ad-728-90-topnews-below">
          <a v-bind:href="advertisements.belowTopNewsAd.advertisersWebPage" v-on:click="
            updateAdvertisementClicks(
              advertisements.belowTopNewsAd.advertisementID
            )
            " target="_blank">
            <img v-bind:src="advertisements.belowTopNewsAd.absolutePhotoUrl" /></a>
        </div>
        <div v-else class="ad-728-90-topnews-below">
          <GoogleAdSense :adSlot="'9356769245'" :width="728" :height="90" />
        </div>
      </div>
    </div>
    <section class="has-sidebar">
      <div class="container">
        <div class="row" data-sticky_parent>
          <div class="col-lg-8 content-wrapper">
            <div data-sticky_column>
              <CategoryBox v-for="category in categories.slice(0, 1)" :key="'category_' + category.postCategoryID"
                v-bind:categoryID="category.postCategoryID" v-bind:categoryName="category.name"
                v-bind:borderColor="category.borderColor" v-bind:adWebPage="advertisements.belowCategoryAds.some(
                  (c) => c.postCategoryID === category.postCategoryID
                )
                  ? advertisements.belowCategoryAds.filter(
                    (c) => c.postCategoryID === category.postCategoryID
                  )[0].advertisersWebPage
                  : null
                  " v-bind:adPhotoUrl="advertisements.belowCategoryAds.some(
    (c) => c.postCategoryID === category.postCategoryID
  )
    ? advertisements.belowCategoryAds.filter(
      (c) => c.postCategoryID === category.postCategoryID
    )[0].absolutePhotoUrl
    : null
    "></CategoryBox>
              <VideoBox></VideoBox>
              <CategoryBox v-for="category in categories.slice(1)" :key="'category_' + category.postCategoryID"
                v-bind:hasMargin="true" v-bind:categoryID="category.postCategoryID" v-bind:categoryName="category.name"
                v-bind:borderColor="category.borderColor" v-bind:adWebPage="advertisements.belowCategoryAds.some(
                  (c) => c.postCategoryID === category.postCategoryID
                )
                  ? advertisements.belowCategoryAds.filter(
                    (c) => c.postCategoryID === category.postCategoryID
                  )[0].advertisersWebPage
                  : null
                  " v-bind:adPhotoUrl="advertisements.belowCategoryAds.some(
    (c) => c.postCategoryID === category.postCategoryID
  )
    ? advertisements.belowCategoryAds.filter(
      (c) => c.postCategoryID === category.postCategoryID
    )[0].absolutePhotoUrl
    : null
    "></CategoryBox>
            </div>
          </div>

          <div class="col-lg-4 sidebar sidebar--right u-md-down-margin-t-20">
            <div id="garminBelowAd300x600" v-if="Math.floor(Math.random() * 10) < 8 &&
              (new Date().getMonth() + 1 == 10 ||
                new Date().getMonth() + 1 == 11)
              " class="ad-300-600-sidebar-above"></div>
            <div v-if="advertisements.aboveSidebarAd != null" class="ad-300-250-sidebar-above">
              <a v-bind:href="advertisements.aboveSidebarAd.advertisersWebPage" v-on:click="
                updateAdvertisementClicks(
                  advertisements.aboveSidebarAd.advertisementID
                )
                " target="_blank">
                <img v-bind:src="advertisements.aboveSidebarAd.absolutePhotoUrl" />
              </a>
            </div>
            <div v-else-if="advertisements.aboveSidebarAd_300_600 != null" class="ad-300-600-sidebar-above">
              <a v-bind:href="advertisements.aboveSidebarAd_300_600.advertisersWebPage
                " v-on:click="
    updateAdvertisementClicks(
      advertisements.aboveSidebarAd_300_600.advertisementID
    )
    " target="_blank">
                <img v-bind:src="advertisements.aboveSidebarAd_300_600.absolutePhotoUrl
                  " /></a>
            </div>

            <div v-else class="ad-300-250-sidebar-above">
              <GoogleAdSense :adSlot="'9248640808'" :width="300" :height="250" />
            </div>
            <div class="side-bar__inner" data-sticky_column>
              <Poll></Poll>
              <MostRecent v-bind:takeCount="8"></MostRecent>
              <div class="widget widget--border-box twitter-feed">
                <div class="widget__title has-ajax-load">
                  <h4>Feed s društvenih mreža</h4>
                </div>
                <div class="twitter-box">
                  <div class="fb-page u-margin-b-10" data-href="https://www.facebook.com/joebiden" data-tabs="timeline"
                    data-width="" data-height="300" data-small-header="true" data-adapt-container-width="true"
                    data-hide-cover="true" data-show-facepile="false">
                    <blockquote cite="https://www.facebook.com/joebiden" class="fb-xfbml-parse-ignore">
                      <a href="https://www.facebook.com/joebiden">Joe Biden</a>
                    </blockquote>
                  </div>
                  <hr />
                  <div class="fb-page u-margin-t-10 u-margin-b-10"
                    data-href="https://www.facebook.com/buducnostsrbijeavucic/" data-tabs="timeline" data-width=""
                    data-height="300" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true"
                    data-show-facepile="false">
                    <blockquote cite="https://www.facebook.com/buducnostsrbijeavucic/" class="fb-xfbml-parse-ignore">
                      <a href="https://www.facebook.com/buducnostsrbijeavucic/">Aleksandar Vučić</a>
                    </blockquote>
                  </div>
                  <hr />
                  <div class="fb-page u-margin-t-10" data-href="https://www.facebook.com/andrej.plenkovic.rh/"
                    data-tabs="timeline" data-width="" data-height="300" data-small-header="true"
                    data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false">
                    <blockquote cite="https://www.facebook.com/andrej.plenkovic.rh/" class="fb-xfbml-parse-ignore">
                      <a href="https://www.facebook.com/andrej.plenkovic.rh/">Andrej Plenković</a>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
            <div id="garminAboveAd300x600" v-if="Math.floor(Math.random() * 10) < 8 &&
              (new Date().getMonth() + 1 == 10 ||
                new Date().getMonth() + 1 == 11)
              " class="ad-300-600-sidebar-below"></div>
            <div v-if="advertisements.belowSidebarAd != null" class="ad-300-250-sidebar-below">
              <a v-bind:href="advertisements.belowSidebarAd.advertisersWebPage" v-on:click="
                updateAdvertisementClicks(
                  advertisements.belowSidebarAd.advertisementID
                )
                " target="_blank">
                <img v-bind:src="advertisements.belowSidebarAd.absolutePhotoUrl" />
              </a>
            </div>
            <div v-else-if="advertisements.belowSidebarAd_300_600 != null" class="ad-300-600-sidebar-below">
              <a v-bind:href="advertisements.belowSidebarAd_300_600.advertisersWebPage
                " v-on:click="
    updateAdvertisementClicks(
      advertisements.belowSidebarAd_300_600.advertisementID
    )
    " target="_blank">
                <img v-bind:src="advertisements.belowSidebarAd_300_600.absolutePhotoUrl
                  " /></a>
            </div>
            <div v-else class="ad-300-250-sidebar-below">
              <GoogleAdSense :adSlot="'5800667610'" :width="300" :height="250" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="full-width call-to-action u-padding-tb-60 u-margin-t-40">
      <div class="container">
        <div class="row u-flex--item-center">
          <div class="col-xl-6 u-lg-down-margin-b-30">
            <div class="content-h">
              <h2>Politicki.ba mobilna aplikacija</h2>
              <h4>
                Za najbolje korisničko iskustvo na Vašem mobilnom uređaju.
              </h4>
            </div>
          </div>
          <div class="col-xl-6">
            <ul class="app-list">
              <li class="ios">
                <a href="https://apps.apple.com/us/app/politicki.ba/id1523032178" target="_blank">
                  <div class="icon">
                    <img src="/src/assets/img/icon/apple.png" alt="Apple Store" />
                  </div>
                  <div class="text">
                    <p>Dostupno na</p>
                    <h3>App Store</h3>
                  </div>
                </a>
              </li>
              <li class="md">
                <a href="https://play.google.com/store/apps/details?id=ba.breakpoint.politickiba" target="_blank">
                  <div class="icon">
                    <img src="/src/assets/img/icon/play-store.png" alt="Google Play Store" />
                  </div>
                  <div class="text">
                    <p>Preuzmi na</p>
                    <h3>Google Play</h3>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="garminBottomAd728x90" v-if="(new Date().getDate() == 8 || new Date().getDate() == 15) &&
        new Date().getMonth() + 1 == 9
        " class="ad-728-90-homepage-bottom"></div>
      <div v-if="advertisements.homepageBottom != null" class="ad-728-90-homepage-bottom">
        <a v-bind:href="advertisements.homepageBottom.advertisersWebPage" v-on:click="
          updateAdvertisementClicks(
            advertisements.homepageBottom.advertisementID
          )
          " target="_blank">
          <img v-bind:src="advertisements.homepageBottom.absolutePhotoUrl" /></a>
      </div>
      <div v-else class="ad-728-90-homepage-bottom">
        <GoogleAdSense :adSlot="'6096181085'" :width="728" :height="90" />
      </div>
    </section>
  </div>
</template>

<script>
import { NewsService, CategoriesService, AdvertisementsService } from '../common/api.service'
import GoogleAdSense from "../components/GoogleAdSense.vue";
import Breadcrumb from '../components/Breadcrumb.vue'
import MostRecent from '../components/MostRecent.vue'
import CategoryBox from '../components/CategoryBox.vue'
import PopularBox from '../components/PopularBox.vue'
import Poll from '../components/Poll.vue'
import TagsBox from '../components/TagsBox.vue'
import VideoBox from '../components/VideoBox.vue'
import postscribe from 'postscribe';

export default {
  name: "Home",
  components: { GoogleAdSense, Breadcrumb, MostRecent, CategoryBox, Poll, TagsBox, VideoBox },
  metaInfo: {
    title: 'Politicki.ba',
  },
  data() {
    return {
      topPosts: [],
      categories: [],
      highlightedPosts: [],
      topNews: [],
      advertisements: {
        aboveTopNewsAd: null,
        belowTopNewsAd: null,
        aboveSidebarAd: null,
        belowSidebarAd: null,
        aboveSidebarAd_300_600: null,
        belowSidebarAd_300_600: null,
        homepageBottom: null,
        abovePromoAd: null,
        premiumBillboardAd: null,
        belowCategoryAds: [],
        garminAd300x600: 'https://hrgde.adocean.pl/_' + (new Date()).getTime() + '/ad.js?id=fd7rqcOZiCK7dqmDdZvU1VN20sMqID3ZlMZgKzBZl.P.j7/nc=0/gdpr=0/gdpr_consent=/redir=',
        garminAd728x90: 'https://hrgde.adocean.pl/_' + (new Date()).getTime() + '/ad.js?id=9io6hGOJky3ajlfKaELFGhgJ4jcovN5.4fMAMaBwRfX.d7/nc=0/gdpr=0/gdpr_consent=/redir='
      },
      advertisementTypes: {
        TOP_NEWS_ABOVE: 1,
        TOP_NEWS_BELOW: 2,
        SIDEBAR_UP: 3,
        SIDEBAR_DOWN: 4,
        HOMEPAGE_BOTTOM: 5,
        PROMO_ABOVE: 6,
        CATEGORY_BELOW: 7,
        PREMIUM_BILLBOARD: 9,
        SIDEBAR_UP_300_600: 11,
        SIDEBAR_DOWN_300_600: 10,
      },
    }
  },
  mounted() {
    if(FB && FB.XFBML)
  {
    FB.XFBML.parse();

  }

    var vueInstance = this;

    setTimeout(() => {
      postscribe('#garminAboveAd300x600', "<script src=" + vueInstance.advertisements.garminAd300x600 + "><\/script>");
      postscribe('#garminBelowAd300x600', "<script src=" + vueInstance.advertisements.garminAd300x600 + "><\/script>");
      postscribe('#garminBottomAd728x90', "<script src=" + vueInstance.advertisements.garminAd728x90 + "><\/script>");
      postscribe('#garminTopNewsBelowAd728x90', "<script src=" + vueInstance.advertisements.garminAd728x90 + "><\/script>");
    }, 1000);

  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData: function () {
      NewsService.getTopXForHomePage(5).then(res => this.topPosts = res.data);
      CategoriesService.getAllPostCategories().then(res => {
        this.categories = res.data.filter(r => r.postCategoryID !== 16 && r.postCategoryID !== 14);
        AdvertisementsService.getActive().then(res => {
  const ads = res.data;
  const updateImpressionsForAdIds = [];
  const advertisementTypes = this.advertisementTypes;

  // Group ads by advertisementTypeID for efficient access
  const adsByType = {};
  ads.forEach(ad => {
    if (!adsByType[ad.advertisementTypeID]) {
      adsByType[ad.advertisementTypeID] = [];
    }
    adsByType[ad.advertisementTypeID].push(ad);
  });

  // Helper to get a random ad by type
  const getRandomAdByType = (typeID) => {
    const filteredAds = adsByType[typeID] || [];
    return filteredAds.length > 0
      ? filteredAds[Math.floor(Math.random() * filteredAds.length)]
      : null;
  };

  // Assign ads to their respective positions
  this.advertisements.aboveTopNewsAd = getRandomAdByType(advertisementTypes.TOP_NEWS_ABOVE);
  this.advertisements.belowTopNewsAd = getRandomAdByType(advertisementTypes.TOP_NEWS_BELOW);
  this.advertisements.aboveSidebarAd = getRandomAdByType(advertisementTypes.SIDEBAR_UP);
  this.advertisements.belowSidebarAd = getRandomAdByType(advertisementTypes.SIDEBAR_DOWN);
  this.advertisements.aboveSidebarAd_300_600 = getRandomAdByType(advertisementTypes.SIDEBAR_UP_300_600);
  this.advertisements.belowSidebarAd_300_600 = getRandomAdByType(advertisementTypes.SIDEBAR_DOWN_300_600);
  this.advertisements.homepageBottom = getRandomAdByType(advertisementTypes.HOMEPAGE_BOTTOM);
  this.advertisements.abovePromoAd = getRandomAdByType(advertisementTypes.PROMO_ABOVE);
  this.advertisements.premiumBillboardAd = getRandomAdByType(advertisementTypes.PREMIUM_BILLBOARD);

  // Collect impression IDs
  [
    this.advertisements.aboveTopNewsAd,
    this.advertisements.belowTopNewsAd,
    this.advertisements.aboveSidebarAd,
    this.advertisements.belowSidebarAd,
    this.advertisements.aboveSidebarAd_300_600,
    this.advertisements.belowSidebarAd_300_600,
    this.advertisements.homepageBottom,
    this.advertisements.abovePromoAd,
    this.advertisements.premiumBillboardAd
  ].forEach(ad => {
    if (ad) {
      updateImpressionsForAdIds.push(ad.advertisementID);
    }
  });

  const categoryAds = adsByType[advertisementTypes.CATEGORY_BELOW] || [];
  this.categories.forEach(category => {
    const adsForCategory = categoryAds.filter(c => c.postCategoryID === category.postCategoryID);
    if (adsForCategory.length > 0) {
      const randomAd = adsForCategory[Math.floor(Math.random() * adsForCategory.length)];
      this.advertisements.belowCategoryAds.push(randomAd);
      updateImpressionsForAdIds.push(randomAd.advertisementID);
    }
  });

  if (updateImpressionsForAdIds.length > 0) {
    AdvertisementsService.updateImpressions(updateImpressionsForAdIds).then(res => {
    }).catch(err => {
    });
  }
});

      });
      NewsService.getHighlighted(0, 10)
        .then(res => {
          this.highlightedPosts = res.data;
          for (var i = 0; i < this.highlightedPosts.length; i++) {
            this.topNews.push({
              postId: this.highlightedPosts[i].postID,
              categoryColor: this.highlightedPosts[i].postCategoryBorderColor,
              postCategory: this.highlightedPosts[i].postCategory,
              title: this.highlightedPosts[i].title,
              searchCode: this.highlightedPosts[i].searchCode,
              content(createElement, content) {
                return createElement('div', { class: 'inner__carousel__item' }, [
                  createElement('div', { class: 'item__category', style: `color: ${content.categoryColor}` }, [`${content.postCategory}:`]),
                  createElement('div', { class: 'item__content' }, [
                    createElement('span', { class: 'item__title' }, [
                      createElement('router-link', { props: { to: `/${content.postCategory}/${content.searchCode}/${content.postId}` } }, [`${content.title}`])])])
                ]);
              },
            });
          }
        });
    },
    nextNews: function () {
      this.$refs.carousel.next();
    },
    prevNews: function () {
      this.$refs.carousel.prev();
    },
    read: function (postID, slug, category) {
      this.$router.push({ name: 'read', params: { category: category, slug: slug, id: postID } });
    },
    updateAdvertisementClicks(advertisementID) {
      AdvertisementsService.updateClicks(advertisementID).then(res => { });
    }
  }

}
</script>

<style scoped>
.carousel {
  -webkit-user-select: auto !important;
  /* Safari */
  -ms-user-select: auto !important;
  /* IE 10+ and Edge */
  user-select: auto !important;
  /* Standard syntax */
  width: 90% !important;
}

.grid-item:nth-child(-n + 2) img {
  object-fit: cover;
  width: 100%;
  height: 340px;
}

.grid-item:nth-child(n + 3) img {
  object-fit: cover;
  width: 100%;
  height: 250px;
}

.header__breaking-news {
  background: #f6f6f6;
}

.cursor-pointer {
  cursor: pointer;
}

.breaking-news {
  position: absolute;
  top: 10px;
  right: 10px;
}

.breaking-news a {
  color: white;
  border-radius: 3px;
  padding-right: 7px;
  padding-left: 7px;
  padding-top: 3px;
  padding-bottom: 3px;
}

.ad-728-90-topnews-above {
  margin-top: -20px;
  margin-bottom: 20px;
  text-align: center;
}

.ad-970-250-topnews-above {
  margin-top: -20px;
  margin-bottom: 20px;
  text-align: center;
}

.ad-728-90-topnews-below {
  margin-top: 20px;
  margin-bottom: -20px;
  text-align: center;
}

.ad-300-250-sidebar-above,
.ad-300-600-sidebar-above {
  text-align: center;
  margin-bottom: 40px;
}

.ad-300-250-sidebar-below,
.ad-300-600-sidebar-below {
  text-align: center;
  margin-top: 40px;
}

.ad-728-90-homepage-bottom {
  margin-top: 50px;
  text-align: center;
}

>>>.item__title a {
  color: #414141;
}

>>>.item__title a:hover {
  color: #007bff;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue